const turnMsToSeconds = (millis) => {
  const ms = parseInt((millis % 1000), 10);
  const sec = parseInt((millis / 1000) % 60, 10);
  const min = Math.floor(millis / 60000);

  return {
    ms,
    sec,
    // eslint-disable-next-line
    complete: `${min}:${sec}`
  };
};
export {
  turnMsToSeconds,
  turnMsToSeconds as default
};
